export default "/images/vendor/flag-icon-css/flags/1x1/sh.svg?acd7b6efcbb9ea9ca7e6f87ca23d5b9b";